import { useNow } from '../hooks/useNow'

/**
 * "Actualizado hace 5m" — badge pequeño para indicar cuándo se refrescó la
 * data. Usa useNow() para auto-actualizarse cada 30s sin re-renderizar todo.
 *
 * Usa `timestamp` (ms epoch) — típicamente `query.dataUpdatedAt` de
 * TanStack Query, o cualquier Date.now() del backend.
 */
export function LastUpdated({
  timestamp,
  className = '',
  label = 'Actualizado',
}: {
  timestamp: number | null | undefined
  className?: string
  label?: string
}) {
  const now = useNow()

  if (!timestamp) return null

  const ago = formatRelative(timestamp, now)

  return (
    <span
      className={`text-xs text-eve-muted ${className}`}
      title={new Date(timestamp).toLocaleString()}
    >
      {label} {ago}
    </span>
  )
}

function formatRelative(ts: number, now: number): string {
  const seconds = Math.max(0, Math.floor((now - ts) / 1000))
  if (seconds < 5) return 'ahora'
  if (seconds < 60) return `hace ${seconds}s`
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `hace ${minutes}m`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `hace ${hours}h`
  const days = Math.floor(hours / 24)
  return `hace ${days}d`
}